module.exports = __webpack_public_path__ + "static/media/welcome.48a94696.svg";